import React from 'react';
import routes from 'router/routes';
import RequireAuthentication from 'hoc/RequireAuthentication';
import RequireRouteEnable from 'hoc/RequireRouteEnable';
import PageNotFound from 'internal/components/PageNotFound';
import { Route, Routes } from 'react-router-dom';
import AppLayout from '../Layouts/AppLayout';
import { Outlet } from 'react-router';

// TODO: add hide function etc like other router

const Router = React.memo(() => {
  const routesWithAppLayout = Object.entries(routes).filter(
    ([, route]) => !route.layout || route.layout.displayName === 'AppLayout'
  );

  return (
    <Routes>
      <Route
        path={'/'}
        element={
          <AppLayout>
            <Outlet />
          </AppLayout>
        }
      >
        {routesWithAppLayout.map(([, { element, path, privateRoute, children }]) => {
          if (!element) throw new Error('component is not defined');

          const Component = !privateRoute
            ? RequireRouteEnable(element, path)
            : RequireRouteEnable(RequireAuthentication(element), path);

          return children ? (
            <Route key={path} path={path} element={<Component />}>
              {Object.entries(children).map(([, subRoute]) => {
                if (!subRoute.element) throw new Error('component is not defined');
                const SubRouteComponent = subRoute.element;

                return (
                  <Route
                    key={subRoute.path}
                    path={subRoute.path}
                    index={subRoute.path === ''}
                    element={<SubRouteComponent />}
                  />
                );
              })}
            </Route>
          ) : (
            <Route key={path} path={path} element={<Component />} />
          );
        })}
        <Route path={'/404'} element={<PageNotFound />} />
      </Route>
      <Route
        path={'*'}
        element={
          <AppLayout>
            <PageNotFound />{' '}
          </AppLayout>
        }
      />
    </Routes>
  );
});

export default Router;
